// extracted by mini-css-extract-plugin
module.exports = {"ErrorBoundary":"ErrorBoundary_ErrorBoundary__3_LMf"};